import { render, staticRenderFns } from "./Candidatepartners.vue?vue&type=template&id=43f18f10&"
import script from "./Candidatepartners.vue?vue&type=script&lang=js&"
export * from "./Candidatepartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f18f10')) {
      api.createRecord('43f18f10', component.options)
    } else {
      api.reload('43f18f10', component.options)
    }
    module.hot.accept("./Candidatepartners.vue?vue&type=template&id=43f18f10&", function () {
      api.rerender('43f18f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/Candidatepartners.vue"
export default component.exports